import AHUsPortfolio from '@/Core.Service.Domain/Controls/AHUs/Views/IndexView.vue';

import EditAHU from '@/Core.Service.Domain/Controls/AHUs/Views/EditAHU.vue';

import AHUCardLayoutGenerator from '@/Core.Service.Domain/Controls/AHUs/Components/AHUCardLayoutBuilder.vue';

export const AHUsRoute = {
  path: 'ahus',
  name: 'AHUsPortfolio',
  component: AHUsPortfolio,
  children: [
    {
      path: 'history/:id',
      name: 'AHUHistory',
    },
  ],
  meta: {
    placeholder: 'Search for an AHU',
    controlTypeName: 'AHU',
    controlTypeId: 5,
    label: 'AHUs',
    toolTip: 'AHU',
    permission: 'controls:read',
    requiresSiteProperty: 'hasAirHandlerUnits',
  },
};

export const AHUCardLayoutRoute = {
  path: 'ahus/layout-builder',
  name: 'AHULayoutBuilder',
  component: AHUCardLayoutGenerator,
  meta: {
    label: 'AHU Layout Builder',
    toolTip: 'Build custom AHU card layouts',
    permission: 'controls:update',
    requiresSiteProperty: 'hasAirHandlerUnits',
  },
};

export const EditAHURoute = {
  path: 'site/:siteId/edit-ahu/:deviceId',
  name: 'EditAHU',
  props: true,
  component: EditAHU,
  meta: {
    label: 'Edit AHU',
    toolTip: 'Edit AHU',
    permission: 'controls:update',
    requiresSiteProperty: 'hasAirHandlerUnits',
  },
};
